import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AmbientTemperature from 'src/screen/v2/Protected/DashboardScreen/AmbientTemperature';
import {
  countFreezingDays, freezingLabel, toForecastDays
} from 'src/screen/v2/Protected/DashboardScreen/AmbientTemperature/ambientTemperature';
import { fetchWeather } from 'src/module/weather/action';
import { getClientId, getTemperatureUnit } from 'src/module/authentication/selector';
import { getWeatherForecast } from 'src/module/weather/selector';
import { useTranslation } from 'src/i18n';

export default function AmbientTemperaturePanel ({ className }: { className?: string }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const clientId = useSelector(getClientId);
  const weatherForecast = useSelector(getWeatherForecast);
  const temperatureUnit = useSelector(getTemperatureUnit);

  useEffect(() => {
    dispatch(fetchWeather());
  }, [dispatch, clientId]);

  const days = useMemo(
    () => toForecastDays(weatherForecast.get('forecast'), { unit: temperatureUnit, t }),
    [weatherForecast, temperatureUnit, t]
  );

  if (!weatherForecast.get('city') || !days.length) return null;

  return (
    <AmbientTemperature
      days={days}
      freezingDayCount={countFreezingDays(days)}
      freezingLabel={freezingLabel(temperatureUnit)}
      className={className}
    />
  );
}
